export default {
    appURLBase: '', // The TLD where the domain sits (e.g. https://example.com/)
    appSubPath: '', // If the app sits in a subdirectory/subdirectories, enter the rest of the path here. 
                                   // For example, if the app sits in https://example.com/apps/coalition, this value should be 'apps/coalition'
    themeColor: '#4575cc' // Controls website theme color, works for smartphone browsers like chrome on android
}